<template>
<common-dialog
  :show.sync="innerShow"
  title="拒签详情"
  :show-footer="false"
>
  <div class="reject-visa-detail" v-if="rejectVisaInfo">
    <div class="top-info">
      <div class="reject-info-item">
        <div class="item-label">办理状态</div>
        <div class="item-content">{{apStatus[rejectVisaInfo.applicant_status]}}</div>
      </div>
      <div class="reject-info-item">
        <div class="item-label">原因</div>
        <div class="item-content">{{rejectVisaInfo.reason}}</div>
      </div>
    </div>
    <div class="bottom-info" v-if="rejectVisaInfo.reject_file && rejectVisaInfo.reject_file.length">
      <div class="reject-info-item">
        <div class="item-label">拒签资料</div>
        <div class="item-content">
          <div class="file-list">
            <div class="file-item" v-for="item in rejectVisaInfo.reject_file" :key="item">
              <img class="file-icon" :src="getFileIcon(item.url)" alt="">
              <div class="s-btn btn-mini btn-blue is-plain" @click="downloadFile(item.url)">下载</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</common-dialog>
</template>

<script>
import CommonDialog from '../../common/modals/common-dialog/common-dialog.vue';
import status from '../../../libs/status.js';
import orderingService from '../../../services/ordering-service';

export default {
  name: '',
  components: {
    CommonDialog,
  },
  props: {
    show: Boolean,
    user_order_id: Number,
    order_applicant_id: Number,
  },
  data() {
    return {
      apStatus: status.apStatus,
      rejectVisaInfo: null,
    };
  },
  computed: {
    innerShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
  },
  watch: {
    innerShow() {
      if (this.innerShow) {
        this.init();
      }
    },
  },
  created() {},
  methods: {
    init() {
      this.rejectVisaInfo = null;
      this.getRejectVisaInfo();
    },
    getRejectVisaInfo() {
      orderingService.getApplicantRejectVisaDetail({
        user_order_id: this.user_order_id,
        applicant_id: this.order_applicant_id,
      }).then((res) => {
        this.rejectVisaInfo = res;
      });
    },
    getFileIcon(url) {
      if (url.indexOf('pdf') > -1) {
        return 'https://o.666visa.cn/static/ssqwxa/order/file-type-icon/icon-pdf.png';
      } else if (
        ['doc', 'docx'].some(item => url.indexOf(item) > -1)
      ) {
        return 'https://o.666visa.cn/static/ssqwxa/order/file-type-icon/icon-word.png';
      } else if (
        ['xls', 'xlsx', 'csv'].some(item => url.indexOf(item) > -1)
      ) {
        return 'https://o.666visa.cn/static/ssqwxa/order/file-type-icon/icon-excel.png';
      }
      return 'https://o.666visa.cn/static/ssqwxa/order/file-type-icon/icon-img.png';
    },
    downloadFile(url) {
      window.open(url);
    },
  },
};
</script>

<style scoped lang="less">
.reject-visa-detail{
  padding: 12px 24px;
  .reject-info-item{
    display: flex;
    align-items: flex-start;
    padding: 12px 0;
    .item-label{
      flex-shrink: 0;
      color: #2F333D;
      font-size: 16px;
      line-height: 22px;
      width: 64px;
      text-align: right;
    }
    .item-content{
      margin-left: 24px;
      flex-grow: 1;
      overflow: hidden;
      color: #2F333D;
      line-height: 22px;
      font-size: 16px;
      .file-list{
        display: flex;
        flex-wrap: wrap;
        margin-right: -24px;
        margin-bottom: -24px;
        .file-item{
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 24px;
          margin-bottom: 24px;
          .file-icon{
            width: 84px;
            height: 84px;
          }
          .s-btn{
            margin-top: 12px;
          }
        }
      }
    }
  }

  .bottom-info{
    border-top: 1px dashed #E9EEF2;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/order-detail/modals/order-reject-visa-detail-dialog.vue